import { styled } from '@material-ui/core';
import BaseButton from '../BaseButton';

const getColourFromVariant = (variant, theme) => {
  switch (variant) {
    case 'primary':
      return {
        backgroundColour: theme.palette.xpl.secondary.default,
        hoverColour: theme.palette.xpl.secondary.hover,
      };
    case 'success':
      return {
        backgroundColour: theme.palette.common.success,
        hoverColour: theme.palette.common.success700,
      };
    case 'warning':
      return {
        backgroundColour: theme.palette.common.warning,
        hoverColour: theme.palette.common.warning700,
      };
    case 'info':
      return {
        backgroundColour: theme.palette.common.info,
        hoverColour: theme.palette.common.info700,
      };
    case 'slighter':
      return {
        backgroundColour: theme.palette.common.osloGray,
        hoverColour: theme.palette.common.nevada,
      };
    case 'error':
      return {
        backgroundColour: theme.palette.common.error400,
        hoverColour: theme.palette.common.error600,
      };
    default:
      return {
        backgroundColour: theme.palette.xpl.secondary.default,
        hoverColour: theme.palette.xpl.secondary.hover,
      };
  }
};

export const FilledButtonComponent = styled(BaseButton)(
  ({ variant, theme }) => {
    const { backgroundColour, hoverColour } = getColourFromVariant(
      variant,
      theme
    );
    return {
      fontWeight: 500,
      borderWidth: '0',
      backgroundColor: backgroundColour,
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: hoverColour,
        // Helps remove sticky effect on mobile devices.
        '@media (hover: none)': {
          backgroundColor: backgroundColour,
        },
      },
      '@media (hover: none)': {
        '&:focus': {
          backgroundColor: hoverColour,
        },
      },
      '&:disabled': {
        opacity: '0.5',
      },
    };
  }
);
